import { createContext } from 'react';

export const EditorRefContext = createContext<React.RefObject<HTMLDivElement> | null>(null);
